import { useTranslation } from 'react-i18next';

import { Namespace } from 'enums';

import styles from './HeaderMoreInfo.module.scss';

export const HeaderGuideInfo = () => {
  const { t } = useTranslation(Namespace.PersonalArea);

  return (
    <div className={styles.moreInfo}>
      {t('guideInformation')}{' '}
      <a target="_blank" href="https://wiki.itransition.com/pages/viewpage.action?pageId=787149732" rel="noreferrer">
        {t('here')}
      </a>
    </div>
  );
};
